import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingType } from 'src/app/message-models/training-record-type.class';
import { HelpConsts } from "../../help/models/help-consts";
import { consts } from "../../common/modals/consts";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ITrainingTypeCategoryInfo } from '../../message-models/trainning-record-category.interface';
import { ListDataService } from '../../services/list-data.service';

@Component({
  selector: 'app-training-course-editor',
  templateUrl: './training-course-editor.component.html',
  styleUrls: ['./training-course-editor.component.scss']
})

export class TrainingCourseEditorComponent implements OnInit {
  @Input() trainingType: TrainingType = new TrainingType();
  @Input() heading = 'Editing Training Type';
   

  @Output() choiceMade: EventEmitter<TrainingType> = new EventEmitter<TrainingType>();
  @Output() saveNewTrainingTypeDocumentRequested: EventEmitter<TrainingType> = new EventEmitter<TrainingType>();
  submitted = false;
  helpMessage: string = HelpConsts.TrainingCourseEntrysHelp.sections[0].body;
  showingHelp = false;
  saveAttempted: boolean = false;

 selectedTrainingTypeCategory: ITrainingTypeCategoryInfo;

  allTrainingTypeCategory: ITrainingTypeCategoryInfo[] = [];


  constructor(public modalRef: DynamicDialogRef,
        private listDataService: ListDataService
  ) {

  }

  get isCompanyTraining(): boolean {
    return this.trainingType?.companyId && this.trainingType?.companyId != consts.emptyGuid;
  }

  ngOnInit(): void {

    this.listDataService.getAllTrainTypeCategory().subscribe({
      next: response => {
        this.allTrainingTypeCategory = response;
      }
    });

  }

  cancelClicked() {
    this.modalRef.close();
    this.choiceMade.emit(null);
  }

  saveClicked() {
    this.submitted = true;
    if (!this.trainingType.isValid) {
      return;
    }

    this.modalRef.close();
    this.choiceMade.emit(this.trainingType);
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  saveAndUploadDocument() {

    this.saveAttempted = true;

    if (!this.trainingType.isValid) {
      return;
    }

    this.saveAttempted = false;

    this.modalRef.close();

    let newTrainingType = new TrainingType(this.trainingType);
    this.saveNewTrainingTypeDocumentRequested.emit(newTrainingType);
  }
}
